<template>
  <div class="animated fadeIn">
    <!-- Modal Review -->
    <b-modal
      ref="rowModal"
      lazy
      ok-only
      title="수정하기"
      size="lg"
      @ok="updateRow"
    >
      <b-input-group
        name="nameSet"
        class="mb-2"
      >
        <b-form-input
          v-for="(col, index) in currentRow"
          :key="index"
          :placeholder="index"
          :disabled="true"
        />
      </b-input-group>
      <b-input-group
        name="valueSet"
        class="mb-2"
      >
        <b-form-input
          v-for="(col, index) in currentRow"
          :key="index"
          v-model="currentRow[index]"
          :list="index"
        />
        <datalist
          id="name"
        >
          <option
            v-for="(rem, remIndex) in remnantInfo"
            :key="remIndex"
            :value="rem.name"
          >
            {{ rem.name + '(' + rem.enName + ': ' + rem.birth.split('T')[0]+ ')' }}
          </option>
        </datalist>
        <datalist
          id="email"
        >
          <option
            v-for="(rem, remIndex) in remnantInfo"
            :key="remIndex"
            :value="rem.email"
          >
            {{ rem.name + '(' + rem.enName + ': ' + rem.birth.split('T')[0]+ ')' }}
          </option>
        </datalist>
      </b-input-group>
    </b-modal>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>OMC 리스트</strong>
          </div>
          <b-row>
            <b-col
              md="4"
              class="text-left"
            >
              <b-input-group
                name="partSet"
                prepend="연도"
                label-for="part"
                class="mb-2"
              >
                <b-form-select
                  v-model="term"
                  :disabled="noAuth"
                  :options="termOptions"
                  :state="term !== ''"
                  @change="getOmcList"
                />
              </b-input-group>
            </b-col>
            <b-col
              md="8"
              align-self="end"
            >
              <b-input-group
                name="excelSet"
                prepend="신규"
                label-for="excel"
                class="mb-2"
              >
                <b-form-file
                  v-model="importedExcel"
                  accept=".xlsx, .xls, .csv"
                  :disabled="noAuth || !$store.getters.isRealSuper"
                  @input="readExcel"
                />
                <b-btn
                  variant="primary"
                  size="sm"
                  :disabled="noAuth || !$store.getters.isRealSuper"
                  @click="saveOmcList()"
                >
                  저장
                </b-btn>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col
              md="4"
            >
              <b-form-group
                label="Per page"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                label-for="perPageSelect"
                class="mb-0"
              >
                <b-form-select
                  id="perPageSelect"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <h4>
                <b-badge
                  variant="dark"
                >
                  <strong>Total: {{ totalRows }}</strong>
                </b-badge>
              </h4>
            </b-col>
          </b-row>
          <b-row
            align-h="center"
            class="text-center"
          >
            <b-table
              class="mb-0 table-outline"
              head-variant="light"
              hover
              :items="itemAll"
              :fields="fieldsAll"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template
                v-slot:cell(name)="data"
              >
                <b-button
                  variant="outline-success"
                  size="md"
                  @click="modalOpen(data.index)"
                >
                  <b>{{ data.value }}</b>
                </b-button>
              </template>
              <template
                v-slot:cell(part)="data"
              >
                {{ data.value }}
              </template>
            </b-table>
          </b-row>
          <b-row
            align-h="center"
            class="my-1"
          >
            <b-col
              cols="5"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../api'
import XLSX from 'xlsx'

export default {
  name: 'OMCList',
  data: function () {
    return {
      filter: null,
      filterOn: ['type', 'name', 'email', 'emailOrg', 'church'],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 50, 100],
      remnantInfo: [],
      term: '',
      termOptions: ['2018', '2019', '2020', '2021'],
      itemAll: [],
      noAuth: false,
      fieldsAll: [
        {
          key: 'type',
          label: '지원구분',
          sortable: true
        },
        {
          key: 'name',
          label: '이름',
          sortable: true
        },
        {
          key: 'email',
          label: '이메일',
          sortable: false
        },
        {
          key: 'emailOrg',
          label: 'omc이메일',
          sortable: false
        },
        {
          key: 'church',
          label: '교회',
          sortable: false
        },
        {
          key: 'part',
          label: '학교/전공',
          sortable: false
        },
        {
          key: 'amount',
          label: '금액/학기',
          sortable: false
        }
      ],
      importedExcel: null,
      excelResult: '',
      currentIndex: 0,
      currentRow: []
    }
  },
  mounted () {
    if (this.$store.getters.isSuper) {
      this.getRemnantList()
    } else {
      this.noAuth = true
    }
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    updateRow () {
      Object.keys(this.currentRow).forEach(col => {
        this.itemAll[this.currentIndex][col] = this.currentRow[col]
      })
      this.currentRow = null
      this.currentIndex = 0
    },
    modalOpen (index) {
      if (this.$store.getters.isRealSuper) {
        this.currentRow = Object.assign({}, this.itemAll[index]) /* dict */
        this.currentIndex = index
        this.$refs.rowModal.show()
      }
    },
    getRemnantList () {
      api.request('get', '/admin/remnant/list')
        .then(response => {
          var data = response.data
          this.remnantInfo = data.docs
        })
        .catch(error => {
          alert(error)
        })
    },
    readExcel (event) {
      // get File object from input tag
      const file = this.importedExcel

      // declare FileReader, temp result
      const reader = new FileReader()
      let tmpResult = {}

      // if you use "this", don't use "function(e) {...}"
      reader.onload = (e) => {
        let data = e.target.result
        data = new Uint8Array(data)
        // get excel file
        let excelFile = XLSX.read(data, { type: 'array' })

        // get prased object
        let firstSheet = ''
        excelFile.SheetNames.forEach(function (sheetName) {
          const roa = XLSX.utils.sheet_to_json(
            excelFile.Sheets[sheetName],
            { header: 1 }
          )
          tmpResult[sheetName] = roa
          if (firstSheet === '') {
            firstSheet = sheetName
          }
        })
        this.excelResult = tmpResult[firstSheet]
        this.parseExcelToTable(this.excelResult)
      }
      reader.readAsArrayBuffer(file)
    },
    parseExcelToTable (docs) {
      // 0번 - 빈칸
      // 1번 - 타입
      // 2번 - 이름
      // 3번 - 이메일
      // 4번 - 교회
      // 5번 - 학교전공
      // 6번 - 금액
      this.itemAll = []
      docs.forEach(elem => {
        var item = {}
        item['type'] = elem[1]
        item['name'] = elem[2]
        item['church'] = elem[4]
        item['email'] = ''
        item['emailOrg'] = elem[3]
        if (elem[5]) {
          let parts = elem[5].split('/')
          if (parts.length >= 3) {
            item['part'] = parts[0] + '(' + parts[1] + ')'
          } else {
            item['part'] = parts[0]
          }
        }
        item['amount'] = elem[6]
        this.itemAll.push(item)
      })
      this.totalRows = this.itemAll.length
    },
    parseDocsToTable (docs) {
      this.itemAll = []
      docs.forEach(elem => {
        var item = Object.assign({}, elem) /* dict */
        this.itemAll.push(item)
      })
      this.totalRows = this.itemAll.length
    },
    getOmcList () {
      api.request('get', '/omc/list?year=' + this.term)
        .then(response => {
          var data = response.data
          this.parseDocsToTable(data.docs)
        })
        .catch(error => {
          alert(error)
        })
    },
    saveOmcList () {
      // post arg 세팅
      if (this.term === '') {
        console.log('Check year')
        return
      }
      var postArg = { 'year': this.term, 'docs': [] }
      this.itemAll.forEach(item => {
        var newDoc = Object.assign({}, item) /* dict */
        newDoc.year = this.term
        newDoc.omcId = this.term + '-omc-' + item.email
        if (newDoc.email === '') {
          newDoc.email = newDoc.name
        }
        postArg.docs.push(newDoc)
      })
      api.request('post', '/omc/regist', postArg)
        .then(response => {
          var data = response.data
          console.log(data)
          /* 200 이면  data에 바로 doc정보가 있거나, data.error가 있음
             400 이면 erros.response.data.error */
        })
        .catch(error => {
          alert(error)
        })
    }
  }
}
</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
